import axios from "../Axios/Default";
// axios.defaults.baseURL = process.env.REACT_APP_URL_HUAWEI;
// const access_token = localStorage.getItem("access_token");
// axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};
// const station_get = localStorage.getItem("station_get");

export const GetDataStation = (stasion_id) => {
  const promise = axios.get("/rts/device-status/" + stasion_id, config);
  return promise;
};

export const GetDataStatistic = (stasion_id) => {
  const promise = axios.get("/rts/statistik/" + stasion_id, config);
  return promise;
};

export const GetDataEnvirontment = (stasion_id) => {
  const promise = axios.get("/rts/environment/" + stasion_id, config);
  return promise;
};

export const DoChangeStatusCoachMark = (data) => {
  const promise = axios.put("/coachmark/" + data, config);
  return promise;
}

export const GetLonLat = (stasion_id) => {
  const promise = axios.get("/lon-lat/get/" + stasion_id, config);
  return promise;
};

export const GetWeather = (data) => {
  const promise = axios.post("/weather/get", data, config);
  return promise;
};


export const GetAlarmList = (data) => {
  const promise = axios.get("/rts/list-alarm", data, config);
  return promise;
};


export const GetBattery = (stasion_id) => {
  const promise = axios.get("/rts/battery/" + stasion_id, config);
  return promise;
};